import { Search, X } from '@alchemer/ui/icons';
import { tw } from '@/lib/tailwind';

interface ShareSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}

function ShareSearchBar({ value, onChange, inputRef }: ShareSearchBarProps) {
  return (
    <label
      className={tw(
        `flex w-full items-center gap-1.5 self-start`,
        `border-border rounded-xs border bg-white`,
        `px-2 py-1 text-[1em]`,
        `focus-within:border-billiard-700`,
      )}
    >
      <Search className="h-4 w-4 text-gray-500" />
      <input
        ref={inputRef}
        aria-label="Search users"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border-0 outline-0"
        placeholder="Search by name or email"
      />
      {value && (
        <button
          type="button"
          aria-label="Clear search"
          className={tw(
            'focus-visible:ring-billiard-700 rounded focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none',
          )}
          onClick={() => onChange('')}
        >
          <X className={tw('h-4 w-4 text-gray-400 hover:text-gray-600')} />
        </button>
      )}
    </label>
  );
}

export { ShareSearchBar };
